import React from 'react';
import { getAlphabetArray, getNumericalArray } from 'utils';
import styles from './index.module.scss';

const ItemAddress = props => {
  const {
    addressType,
    inventoryAddress,
    editInfo,
    loading,
    setAddress,
    labelClass,
  } = props;

  const AddressDropdown = props => {
    const {
      value,
      type,
      options,
      addressPropertyKey,
      defaultOptionText,
      defaultOptionHidden,
    } = props;
    
    const handleChange = (propertyKey: string, propertyValue: string | number) => {
      const address = {
        ...inventoryAddress,
        [propertyKey]: propertyValue,
      };
      setAddress(addressType.toLowerCase(), address);
    };
    
    return (
      <div>
        <select
          className={'form-control'}
          disabled={loading}
          value={value}
          onChange={e => handleChange(
            addressPropertyKey,
            type === 'string' ? e.target.value : parseInt(e.target.value),
          )}
        >
          <option hidden={defaultOptionHidden}>{defaultOptionText}</option>
          {options.map(option => (
            <option key={option} value={option}>{option}</option>
          ))}
        </select>
      </div>
    );
  };
  
  return (
    <div className={styles['item-address']} style={{ flex: 1, flexDirection: 'column', minWidth: 100 }}>
      <div className={`${styles['label']} ${labelClass}`}>{`Inventory ${addressType} Address`}</div>
      {!editInfo ? (
        <div className={styles['info']}>
          {!!inventoryAddress ? inventoryAddress.addressString : 'N/A'}
        </div>
      ) : (
        <div className={styles['item-address-dropdown-container']}>
          <div>
            <div className={styles['label']}>Storage Section</div>
            <AddressDropdown
              value={inventoryAddress?.storageSection}
              addressPropertyKey={'storageSection'}
              type={'string'}
              defaultOptionText={'Select a storage section'}
              defaultOptionHidden={!!inventoryAddress?.storageSection}
              options={getAlphabetArray()}
            />
          </div>
          <div>
            <div className={styles['label']}>Furniture Number</div>
            <AddressDropdown
              value={inventoryAddress?.furnitureNo}
              addressPropertyKey={'furnitureNo'}
              type={'number'}
              defaultOptionText={'Select a furniture number'}
              defaultOptionHidden={!!inventoryAddress?.furnitureNo}
              options={getNumericalArray(100)}
            />
          </div>
          <div>
            <div className={styles['label']}>Shelf Number</div>
            <AddressDropdown
              value={inventoryAddress?.shelfNo}
              addressPropertyKey={'shelfNo'}
              type={'number'}
              defaultOptionText={'Select a shelf number'}
              defaultOptionHidden={!!inventoryAddress?.shelfNo}
              options={getNumericalArray(200)}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default ItemAddress;